import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const CartItem = ({ item, onUpdateQuantity, onRemove, onFormatChange }) => {
  const quantityOptions = [
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5' }
  ];

  const formatOptions = [
    { value: 'pdf', label: 'PDF' },
    { value: 'epub', label: 'EPUB' },
    { value: 'mobi', label: 'MOBI' }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 transition-smooth hover:shadow-md">
      <div className="flex flex-col sm:flex-row gap-4 md:gap-6">
        <div className="w-full sm:w-32 md:w-40 flex-shrink-0">
          <div className="aspect-[3/4] rounded-md overflow-hidden bg-muted">
            <Image
              src={item?.image}
              alt={item?.imageAlt}
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="flex-1 min-w-0 space-y-3 md:space-y-4">
          <div>
            <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground line-clamp-2 mb-2">
              {item?.title}
            </h3>
            <p className="text-sm md:text-base text-muted-foreground">
              by {item?.author}
            </p>
          </div>

          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="Download" size={16} />
            <span>Instant Download Available</span>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
            <div className="w-full sm:w-32">
              <Select
                label="Quantity"
                options={quantityOptions}
                value={item?.quantity?.toString()}
                onChange={(value) => onUpdateQuantity(item?.id, parseInt(value))}
              />
            </div>

            <div className="w-full sm:w-40">
              <Select
                label="Format"
                options={formatOptions}
                value={item?.format}
                onChange={(value) => onFormatChange(item?.id, value)}
              />
            </div>
          </div>
        </div>

        <div className="flex sm:flex-col items-center sm:items-end justify-between sm:justify-start gap-3 md:gap-4 pt-3 sm:pt-0 border-t sm:border-t-0 border-border">
          <div className="text-right">
            <p className="text-xl md:text-2xl font-heading font-semibold text-foreground data-text">
              ${item?.price?.toFixed(2)}
            </p>
            {item?.quantity > 1 && (
              <p className="text-xs md:text-sm text-muted-foreground mt-1">
                ${(item?.price / item?.quantity)?.toFixed(2)} each
              </p>
            )}
          </div>

          <Button
            variant="ghost"
            size="sm"
            iconName="Trash2"
            iconSize={18}
            onClick={() => onRemove(item?.id)}
            className="text-error hover:text-error hover:bg-error/10"
          >
            Remove
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CartItem;